import * as ActionTypes from '../constants/actions';

export function showSearch(value, label, type) {
    return {
        type: ActionTypes.SEARCH_SHOW,
        payload: {
            value,
            label,
            type
        }
    }
}

export function hideSearch() {
    return {
        type: ActionTypes.SEARCH_HIDE,
        payload: {}
    }
}

export function changeListType(type) {
    return {
        type: ActionTypes.SEARCH_CHANGE_LIST_TYPE,
        payload: {
            type
        }
    }
}

export function changeFilter(value) {
    return {
        type: ActionTypes.SEARCH_CHANGE_FILTER,
        payload: {
            value
        }
    }
}


// WEBPACK FOOTER //
// ./actions/search.js